import {HarcTuru} from '@/enum/HarcTuru';
import {NumberHelper} from '@/helpers/NumberHelper';

export interface IlkMasrafHarciItem {
    harc_turu_id?: number | null;
    tutar?: number | string | null;
}

export class HarcHelper {
    static readonly ILK_MASRAF_HARC_TURU_IDS: ReadonlyArray<number> = [
        HarcTuru.icraya_basvurma,
        HarcTuru.vekalet_suret,
        HarcTuru.pesin,
    ];

    static isIlkMasrafHarci(harcTuruId?: number | null): boolean {
        if (!harcTuruId) {
            return false;
        }
        return HarcHelper.ILK_MASRAF_HARC_TURU_IDS.includes(harcTuruId);
    }

    static parseTutar(tutar?: number | string | null): number {
        if (tutar === null || tutar === undefined || tutar === '') {
            return 0;
        }
        const parsed = Number(tutar);
        return Number.isFinite(parsed) ? parsed : 0;
    }

    static calculateIlkMasrafToplami(items: IlkMasrafHarciItem[] = []): number {
        const toplam = items.reduce((sum, item) => {
            if (!HarcHelper.isIlkMasrafHarci(item.harc_turu_id)) {
                return sum;
            }
            return sum + HarcHelper.parseTutar(item.tutar);
        }, 0);

        return new NumberHelper().ToNumberFixed(toplam, 2);
    }
}
